// extracted by mini-css-extract-plugin
export default {"root":"yPsC1T","isMobile":"s2Th7e","blackAndWhite":"HEUInH"};